import React, { useEffect, useState, Fragment } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 2
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-8" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FDF4E7 15%, rgb(254,232,232) 40%, rgb(254,232,232) 85%, #FEFAF4 100%)'
  }} data-id="element-100">
      <div className="mx-auto max-w-4xl text-center" data-id="element-101">

        {/* Título */}
        <h2 className="text-lg sm:text-xl font-black m-0 mb-4" style={{
        color: '#1E1208'
      }} data-id="element-102">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        {/* Timer */}
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-103">
          {[{
          value: timeLeft.hours,
          label: 'hs'
        }, {
          value: timeLeft.minutes,
          label: 'min'
        }, {
          value: timeLeft.seconds,
          label: 'seg'
        }].map((item, i) => <Fragment key={item.label} data-id="element-104">
              <div className="flex flex-col items-center" data-id="element-105">
                <span className="text-4xl sm:text-5xl font-black tabular-nums" style={{
              color: 'rgb(220,38,38)'
            }} data-id="element-106">
                  {pad(item.value)}
                </span>
                <span className="text-[10px] uppercase tracking-wide" style={{
              color: '#9A7B5A'
            }} data-id="element-107">
                  {item.label}
                </span>
              </div>
              {i < 2 && <span className="mb-4 text-4xl sm:text-5xl font-black" style={{
            color: 'rgb(220,38,38)'
          }} data-id="element-108">
                  :
                </span>}
            </Fragment>)}
        </div>

        {/* Subtext */}
        <p className="font-bold m-0 mb-5 text-[15px]" style={{
        color: '#1E1208'
      }} data-id="element-109">
          Después sube{' '}
          <span className="font-black text-red-600" data-id="element-110">$15.000 ARS</span>{' '}
          y no vuelve a bajar.
        </p>

        {/* Progress bar */}
        <div className="mx-auto max-w-xl" data-id="element-111">
          <div className="mb-1 flex items-center justify-between" data-id="element-112">
            <span className="text-xs font-bold text-red-500" data-id="element-113">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold" style={{
            color: '#1E1208'
          }} data-id="element-114">
              Quedan pocos
            </span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full" style={{
          backgroundColor: 'rgb(254,226,226)'
        }} data-id="element-115">
            <div className="h-2.5 rounded-full" style={{
            width: '68%',
            background: 'linear-gradient(to right, rgb(239,68,68), rgb(252,165,165))'
          }} data-id="element-116" />
          </div>
          <p className="text-right text-[10px] mt-1 mb-0" style={{
          color: '#9A7B5A'
        }} data-id="element-117">
            68% de los cupos tomados
          </p>
        </div>
      </div>

      {/* Degradé inferior → conecta con Pricing */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-118" />
    </section>;
}